<h1 matDialogTitle>{{'ecase.common.confirm' | eCaseTranslate }}</h1>
<div mat-dialog-content><span [innerHTML]="confirmMessage"></span></div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button style="color: white" class="eCase-dialog-positive-action-button" (click)="dialogRef.close(true)">{{'ecase.common.confirm' | eCaseTranslate}}</button>
    <button mat-raised-button style="color: white" class="eCase-dialog-negative-action-button" (click)="dialogRef.close(false)">{{'ecase.common.cancel' | eCaseTranslate}}</button>
</div>
